import cn from 'classnames';
import type { ProgramMember } from 'models';
import { Avatar, Button, Col, Icon, Link, Row, Text } from 'ui';
import { useConfirmDeleteProgramMember } from '../hooks';

type P = {
  member: ProgramMember;
  programId: string;
  programName: string;
};

const MemberRow = ({ member, programId, programName }: P) => {
  const { confirmDeleteMember, contextHolder, isLoading } = useConfirmDeleteProgramMember();

  return (
    <>
      <Row align="middle" className="program-member-row" gutter={['ms', 0]}>
        <Col>
          <Link to={`/members/${member.id}`}>
            <Avatar size="lg" src={member.profilePhoto}>
              {member.fullName}
            </Avatar>
            <span
              className={cn('program-member-row__status-icon', {
                'program-member-row__status-icon--joined': member.joined,
              })}
            >
              {member.joined ? (
                <Icon className="program-member-row__status-icon-glyph" icon="check-line" size="extra-extra-small" />
              ) : (
                <Icon className="program-member-row__status-icon-glyph" icon="question-line" size="extra-extra-small" />
              )}
            </span>
          </Link>
        </Col>

        <Col flex="1">
          <Row align="middle" className="program-member-row__content" justify="space-between">
            <Col>
              <Text data-test-id="member_name">{member.fullName}</Text>
            </Col>
            <Button
              danger
              icon={<Icon icon="delete-2-line" />}
              loading={isLoading}
              onClick={() => {
                confirmDeleteMember({
                  member,
                  programId,
                  programName,
                });
              }}
              type="link-primary"
            />
          </Row>
        </Col>
      </Row>
      {contextHolder}
    </>
  );
};

export default MemberRow;
